module.exports = __webpack_public_path__ + "static/media/icon-calendar.4744f4ac.svg";